/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelImages = new Class({
    Extends:QuriobotElement,
    template: function(){
        var base =  '<div class="panel--wrapper panel--multiImages{% button-state %} isLoading" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            <div class="panel--navBack">'+
                    '                <span></span>'+
                    '            </div>'+
                    '            <div class="panel--navNext">'+
                    '                <span></span>'+
                    '            </div>'+
                    '            <div class="panel--options">'+
                    '                <div class="panel--optionsSlider">'+
                    '                {% options %}'+
                    '                </div>'+
                    '            </div>'+
                    '        </div>'+
                    '        {% button %}'+
                    '    </div>'+
                    '</div>';

        var option =
          '<div role="checkbox" aria-checked="false" tabindex="0" class="image--option {{ inview }}" aria-label="{{ text }}" data-option-id="{{ id }}" data-url="{{ url }}" data-url-target="{{ urlTarget }}">' +
          '    <div class="image--optionBody">' +
          '        <div class="option--image">' +
          '            <div class="option--imageContent" style="background-image:url(\'{{ image }}\');">' +
          '                <div class="icon--checkWrapper dark">' +
          '                    <div class="check show"></div>' +
          '                </div>' +
          '            </div>' +
          '        </div>' +
          '        <div class="option--text">' +
          '            <span class="option--text--content">{{{ text }}}</span>' +
          '            <span class="option--comment">{{{ comment }}}</span>' +
          '        </div>' +
          '        <div class="image--optionBodyOverlay">' +
          '        </div>' +
          '        <div class="icon--checkWrapper fromBottom circle fast">' +
          '            <div class="check"></div>' +
          '        </div>' +
          '        <div class="panel--overlay">' +
          '            <div class="icon--checkWrapper fromBottom circle">' +
          '                <div class="check"></div>' +
          '            </div>' +
          '            <button type="button" aria-label="' +
          this.data.i18n.redo.button.title +
          '" aria-hidden="true" class="icon--redoWrapper">' +
          '                <div class="redo"></div>' +
          '            </button>' +
          '        </div>' +
          '    </div>' +
          '</div>'

        var button ='<div class="panel--done">'+
                    '    <button type="button" class="done--button" aria-label="Press this button to approve your choice">'+
                    // '        <div class="button--text">{% button-text %}</div>'+
                    '        <div class="button--arrow"></div>'+
                    '    </button>'+
                    '</div>';

        return {'base': base, 'option': option, 'button': button};
    },
    isScrolling:false,
    slideTo: function(nextIndex,fast){
        var nextPosition = nextIndex * this.optionSize(),
            Slider = this.element.getElements('.panel--options')[0],
            SlideTime = (fast)? 150 : 300,
            NewScroll = new Fx.Scroll(Slider,{'duration':SlideTime, fps: 30, 'transition': Fx.Transitions.Sine.easeIn}).start(nextPosition,0);

        setTimeout(function(){
            this.isScrolling = false;
            this.isForcedScroll = false;
        }.bind(this),SlideTime + 100);

        this.optionInView(nextIndex);
        this.isScrolling = true;
    },
    options: function(){
        return this.element.getElements('.image--option');
    },
    optionSize: function(){
        var unselected = [],
            totalsize = 0,
            thisOptions = this.options();
        thisOptions.each(function(oOption,i){
            if(!oOption.hasClass('selected--option')){
                unselected.push(oOption);
                totalsize += oOption.getSize().x;
            }
        });

        if(totalsize === 0) {
            totalsize = thisOptions[0].getSize().x;
        }

        var optionAvg = Math.round(totalsize / (unselected.length < 1 ? 1 : unselected.length));
        return optionAvg;
    },
    slidePos: function(){
        var SlidePos = 0;
        this.options().each(function(opt,i){
            if(opt.hasClass('inview')){
                SlidePos = i;
            }
        });
        return SlidePos;
    },
    optionInView: function(newIndex){
        var bck = this.element.getElements('.panel--navBack')[0];
        var nxt = this.element.getElements('.panel--navNext')[0];

        this.options().each(function(opt,i){
            if(i == newIndex){
                opt.addClass('inview');
            }else{
                opt.removeClass('inview');
            }
        }.bind(this));

        // managing offScreen state for backnav
        if(newIndex == 0){
            bck.addClass('offScreen');
        }else{
            bck.removeClass('offScreen');
        }

        // managing offScreen state for nextnav
        if(newIndex == (this.options().length - 1)){
            nxt.addClass('offScreen');
        }else{
            nxt.removeClass('offScreen');
        }
    },
    scrolled:0,
    scrollMonitor: function(){
        // monitor scrolling ;)
        var slider = this.element.getElements('.panel--options')[0],
            newScrolled = slider.getScroll().x,
            size = this.optionSize(),
            direction = (this.scrolled >= newScrolled)? 'bwd' : 'fwd';

        this.scrolled = newScrolled;

        if(this.scrollTimeout){
            clearTimeout(this.scrollTimeout);
        }
        if(this.isForcedScroll || this.isScrolling){
            return;
        }

        // after scrolling.
        this.scrollTimeout = setTimeout(function(){
            var pos = (this.scrolled / size).toFixed(2),
                posPct = pos.toString().split('.')[1].toInt(),
                newIndex = 0;

            if(direction == 'fwd'){
                if(posPct >= 25){
                    newIndex = Math.ceil(pos);
                }else{
                    newIndex = Math.floor(pos);
                }
            }
            if(direction == 'bwd'){
                if(posPct <= 75){
                    newIndex = Math.floor(pos);
                }else{
                    newIndex = Math.ceil(pos);
                }
            }

            this.slideTo(newIndex,true);

        }.bind(this),100);
    },
    attach: function(){
        var Allowed = this.data.choices,
            Options = this.options(),
            Done = this.element.getElements('.done--button'),
            Nav = this.element.getElements('.panel--navBack,.panel--navNext'),
            Slider = this.element.getElements('.panel--options')[0];

        if(Nav.length){
            Nav.each(function(oButton,i){
                oButton.addEvents({
                    click:function(){
                        if(this.isScrolling){
                            return;
                        }
                        nextIndex = (oButton.hasClass('panel--navNext'))?
                            (this.slidePos() + 1):
                            (this.slidePos() - 1);

                        this.isForcedScroll = true;

                        if(nextIndex >= 0 && nextIndex < this.options().length){
                            this.slideTo(nextIndex);
                        }

                    }.bind(this)
                })
            }.bind(this));
        }

        if(Slider){
            if(BrowserData.isMobile){
                Slider.addClass('onMobile');
                var touchstartX = 0
                var touchendX = 0

                var handleGesure = function () {
                  if (touchendX < touchstartX) {
                    this.element.getElement('.panel--navNext').click()
                  }
                  if (touchendX > touchstartX) {
                    this.element.getElement('.panel--navBack').click()
                  }
                }.bind(this)

                Slider.addEvents({
                    touchstart:function(e){
                        touchstartX = e.changedTouches[0].screenX
                    }.bind(this),
                    touchend:function(e){
                        touchendX = e.changedTouches[0].screenX
                        handleGesure()
                    }.bind(this)
                });
            }else{
                Slider.addEvents({
                    scroll:function(){
                        this.scrollMonitor();
                    }.bind(this)
                });
            }
        }

        this.selected = {
            "values":[],
            "content":[]
        }

        if(Options.length){
            Options.each(function(oOption,i){
                var url = oOption.get('data-url');
                if (url) {
                  this.quriobot.populateURL(url, function(url) {
                      oOption.set('data-url', url);
                  }.bind(this))
                }
                oOption.addEvents({
                    click:function(){
                        if(this.element.hasClass('isAnswered')){
                            return;
                        }
                        var Selected = this.element.getElements('.image--option.selected--option');
                        var url = oOption.get('data-url');
                        var urlTarget = oOption.get('data-url-target')
                        if(Allowed > 1){
                            if(oOption.hasClass('selected--option')){
                                oOption.removeClass('selected--option');
                                oOption.set('aria-checked', false);
                                this.selected.values.erase(oOption.get('data-option-id'));
                                this.selected.content.erase(oOption.getElements('.option--text--content')[0].get('text'));
                            }else{
                                if(Allowed > Selected.length){
                                    oOption.addClass('selected--option');
                                    oOption.set('aria-checked', true);
                                    this.selected.values.push(oOption.get('data-option-id'));
                                    this.selected.content.push(oOption.getElements('.option--text--content')[0].get('text'));
                                    this.openURL(url, urlTarget)
                                }
                            }
                        }else{
                            if(!oOption.hasClass('selected--option')){
                                Selected.removeClass('selected--option');
                                Selected.set('aria-checked', false);
                                oOption.addClass('selected--option');
                                oOption.set('aria-checked', true);
                                this.selected.values.push(oOption.get('data-option-id'));
                                this.selected.content.push(oOption.getElements('.option--text--content')[0].get('text'));
                                this.openURL(url, urlTarget)
                                this.after();
                            }
                        }
                    }.bind(this)
                });
            }.bind(this));
        }

        if(Done.length){
            Done.each(function(oDone,i){
                oDone.addEvents({
                    click:function(){
                        if(this.selected.values.length >= 1 || this.data.is_required === false){
                            this.after();
                        }
                    }.bind(this)
                });
            }.bind(this));
        }
        this.slideTo(0,true);
    },
    populate: function(result){
        if (this.data.meta && this.data.meta.getOptionsScript) {
            this.getOptionsCallback(this.data.meta.getOptionsScript, null, function(options) {
               if (options) {
                   this.data.options = options.map(function(item) {
                       return {
                           image: item.image,
                           id: item.value,
                           text: item.label,
                           comment: item.description,
                       }
                   })
                   QuriobotElement.prototype.populate.bind(this)(result)
               }
            }.bind(this))
        } else {
            return QuriobotElement.prototype.populate.bind(this)(result)
        }
    },
    after: function(hasOther){
        var answerData = {
            answer:{
                'render': false,
                'value': this.selected.values,
                'content': this.selected.content
            }
        };
        this.element.addClass('isAnswered');
        this.answerCallback(this.data, answerData);

        // Add `aria-hidden="true"` after answering to the question
        this.setAriaHidden('.panel--options', true);

        // Remove `aria-hidden="true"` from redo-button
        this.setAriaHidden('.icon--redoWrapper', false);
    }
});
